<app-aside-nav></app-aside-nav>
    <div class="pipi m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
        <div class="m-grid__item m-grid__item--fluid">
            <router-outlet></router-outlet>
        </div>
    </div>
<app-footer></app-footer>